import React from 'react';
import QrReader from 'react-qr-reader';

const parseCodeFromURL = (code: string) => {

  console.log(code)
  // Checks and balances
  if (typeof code !== "string") {
    return false;
  }
  // Check if there is chance that this is URL
  if (!code || code === null || code.length < 5) {
    return false;
  }

  return code;
}

interface ITicketQRScannerProps {
  delay?: number;
  onScan: (code: string) => void;
}

interface ITicketQRScannerState {
  scannedTickets: string[];
}

export default class TicketQRScanner extends React.Component<
  ITicketQRScannerProps,
  ITicketQRScannerState
  > {
  public moduleName = "TicketQRScanner";
  constructor(props) {
    super(props);
    this.handleOnScan = this.handleOnScan.bind(this);
  }

  /**
   * Called when there is QR Code Scanned
   */
  public handleOnScan(scannedContent: string) {
    const code = parseCodeFromURL(scannedContent);
    if (code !== false) {
      this.props.onScan(code);
    }
  }

  /**
   * This is executed when we are in batch mode.
   */
  public handleOnBatchFinished() {
    return true;
  }

  public render() {
    const { delay } = this.props;
    return (
      <div style={{ display: "block", width: "100%", maxWidth: "100%", textAlign: 'center', alignContent: 'center', justifyContent: 'center' }}>
        <p />
        <div style={{ width: '500px', margin: '0 auto', maxWidth: '100%' }}>
          <QrReader
            delay={delay || 1000}
            onError={this.handleOnScan}
            onScan={this.handleOnScan}
            style={{
              width: "100%"
            }}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/campaign/Checkin/TicketQRScanner.tsx